import { createReducer, on } from '@ngrx/store';
import { failStatus, loadingStatus, successStatus } from '@core/models/request-status.model';
import {
  getB2BUnit,
  getB2BUnitFail,
  getB2BUnitSuccess,
  getB2bUnitPaymentMethods,
  getB2bUnitPaymentMethodsFail,
  getB2bUnitPaymentMethodsSuccess,
} from '@b2b/features/b2b-unit/core/store/b2b-unit.actions';
import { B2bUnitState } from '@b2b/features/b2b-unit/core/store/b2b-unit.states';

const initialState: B2bUnitState = {
  currentB2bUnit: {
    data: null,
    hasError: false,
    isLoading: false,
    isPristine: true,
    message: '',
  },
  paymentMethods: {
    data: [],
    hasError: false,
    isLoading: false,
    isPristine: true,
    message: '',
  },
  defaultPaymentMethod: {
    data: null,
    hasError: false,
    isLoading: false,
    isPristine: true,
    message: '',
  },
};

export const b2bUnitReducer = createReducer(
  initialState,

  // B2B Unit Details
  on(getB2BUnit, (state: B2bUnitState): B2bUnitState => {
    return {
      ...state,
      currentB2bUnit: {
        ...state.currentB2bUnit,
        ...loadingStatus,
      },
    };
  }),

  on(getB2BUnitSuccess, (state: B2bUnitState, { b2bUnit: b2bUnitDetails }): B2bUnitState => {
    return {
      ...state,
      currentB2bUnit: {
        data: b2bUnitDetails.data || null,
        isLoading: false,
        isPristine: false,
        hasError: false,
        message: '',
      },
    };
  }),

  on(getB2BUnitFail, (state: B2bUnitState, { message }): B2bUnitState => {
    return {
      ...state,
      currentB2bUnit: {
        ...state.currentB2bUnit,
        ...failStatus,
        data: null,
        message,
      },
    };
  }),

  // Payment Methods
  on(getB2bUnitPaymentMethods, (state: B2bUnitState): B2bUnitState => {
    return {
      ...state,
      paymentMethods: {
        ...state.paymentMethods,
        ...loadingStatus,
      },
    };
  }),

  on(getB2bUnitPaymentMethodsSuccess, (state: B2bUnitState, { paymentMethods }): B2bUnitState => {
    return {
      ...state,
      paymentMethods: {
        ...state.paymentMethods,
        ...paymentMethods,
        ...successStatus,
      },
    };
  }),

  on(getB2bUnitPaymentMethodsFail, (state: B2bUnitState, { message }): B2bUnitState => {
    return {
      ...state,
      paymentMethods: {
        ...initialState.paymentMethods,
        ...failStatus,
        message,
      },
    };
  }),
);
